var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ELSTextBox } from '@els/els-component-form-field-react';
import classNames from 'classnames';
import React from 'react';
var SearchBar = function (_a) {
    var id = _a.id, value = _a.value, handleSearch = _a.handleSearch, focusHandler = _a.focusHandler, keyDownHandler = _a.keyDownHandler, customClass = _a.customClass, ariaLabel = _a.ariaLabel, iconRight = _a.iconRight, _b = _a.iconLeft, iconLeft = _b === void 0 ? 'search' : _b, _c = _a.iconLeftPrefix, iconLeftPrefix = _c === void 0 ? 'gizmo' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.iconRightPrefix, iconRightPrefix = _e === void 0 ? 'gizmo' : _e, autoFocus = _a.autoFocus, ariaAttrs = _a.ariaAttrs;
    return (<ELSTextBox id={id} iconLeft={iconRight ? undefined : iconLeft} iconLeftPrefix={iconLeftPrefix} iconRight={iconRight} iconRightPrefix={iconRightPrefix} placeholder={placeholder} value={value} changeHandler={handleSearch} cssClasses={classNames('c-search-bar', customClass)} focusHandler={focusHandler} keyDownHandler={keyDownHandler} autoFocus={autoFocus} ariaAttrs={__assign({ 'aria-label': ariaLabel || placeholder || 'Search' }, ariaAttrs)}/>);
};
export default SearchBar;
